/* globals window , $ */
'use strict';

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
  let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, n));

  return (c ? num.replace('.', c) : num).replace(
    new RegExp(re, 'g'),
    '$&' + (s || ','),
  );
};

$.extend($.easing, {
  easeInOutQuint: function (x, t, b, c, d) {
    if ((t /= d / 2) < 1) {
      return (c / 2) * t * t * t * t * t + b;
    }
    return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  },
});

$(function () {
  let root = $('.portfolio');

  const graphs = root.find('.graphs-wrapper');
  $(window).bind('scroll.graphs', function () {
    let rect = graphs[0].getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
    if (visible) {
      $(window).unbind('.graphs');
      graphs.find('.graph__col').each(function (i, e) {
        let delay = i * 60;
        setTimeout(function () {
          $(e).addClass('graph__col--loaded');
        }, delay);
      });
    }
  });

  let costsContainer = root.find('.costs');
  let ranger = root.find('input[type=range]');
  let min = ranger.attr('min');
  let max = ranger.attr('max');
  let priceBox = root.find('.price-box');
  let investment = root.find('.price-box__investment .price-box__value');
  let cost = root.find('.price-box__cost .price-box__value-container');
  let costValue = cost.find('.price-box__value');
  let link = root.find('a.price-box__cost');
  let indicator = root.find('.price-box__indicator');
  //let link = $('<a class="price-box__read-more" href="/what">Läs&nbsp;mer</a>')
  /*
    Ranges:
    0.0 -> 0.5: 0 -> 100 000 kr investment
    0.5 -> 0.9: 100 000 -> 5 000 000 kr investment
    0.9 -> 1.0: 5 000 000 -> 9 000 000 kr investment
   */
  let prev = -1;
  ranger.on('input change', function () {
    let p = this.value / (max - min);
    ranger.attr('style', '--progress: ' + p * 100 + '%');
    let inv =
      p <= 0.5
        ? Math.round(((p / 0.5) * 100000) / 100) * 100
        : p < 0.9
          ? 100000 + Math.round((((p - 0.5) / 0.4) * 4900000) / 1000) * 1000
          : 5000000; //+ Math.round(((p-0.9)/0.1*4000000)/10000)*10000
    investment.html(Math.round(inv).format(0, 3, ' ', '.'));
    let rangerWidth = ranger.outerWidth();
    let priceBoxWidth = priceBox.outerWidth();
    let thumbSize = (rangerWidth * 56) / 640; // Default thumb and ranger size
    let ratio = rangerWidth / priceBoxWidth;
    let start = (1 - ratio) / 2 + thumbSize / 2 / priceBoxWidth;
    let current = (1 - start * 2) * p;
    indicator.css('left', (start + current) * 100 + '%');
    if (inv >= 5000000) {
      if (prev < 5000000) {
        link.attr('href', link.data('href'));
        cost.one(
          'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
          function () {
            // Don't add the class if the value has changed since the animation started
            if (ranger.val() / (max - min) >= 0.9) {
              cost.addClass('wm--loaded');
            }
          },
        );
        costValue.html(
          Math.round((5000000 * (0.5 + 0.09)) / 100.0 / 12).format(
            0,
            3,
            ' ',
            '.',
          ),
        );
        costsContainer.addClass('wm');
      }
    } else {
      if (prev >= 5000000) {
        cost.removeClass('wm--loaded');
        costsContainer.removeClass('wm');
        link.removeAttr('href');
      }
      costValue.html(
        Math.round((inv * (0.5 + 0.09)) / 100.0 / 12).format(0, 3, ' ', '.'),
      );
    }
    prev = inv;
  });
  ranger.val(0).change();

  // Animate the slider when it scrolls into view
  $(window).bind('scroll.ranger', function () {
    let rect = priceBox[0].getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
    if (visible) {
      $(window).unbind('.ranger');
      ranger.val(0).change();
      ranger.animate(
        {
          value: min + (max - min) / 2,
        },
        {
          duration: 1400,
          easing: 'easeInOutQuint',
          step: function () {
            ranger.change();
          },
        },
      );
    }
  });
});
